import React from "react";
import arrowLeft from "../../../Assets/Icons/left-arrow.svg";
import "./styles.css";
import ChatBar from "./ChatBar";
import ChatEdit from "./ChatEdit";
import Button from "../Buttons/Button";
import { useNavigate } from "react-router-dom";

const MessageSection = ({ messages, patientDetails, handleNewMessage }) => {
  const navigate = useNavigate();

  return (
    <div className="message-section-frame">
      <div className="message-heading" style={{ justifyContent: "flex-end" }}>
        {/* <h3 style={{ fontWeight: "500" }}>Message</h3> */}
        <Button
          btnType="back"
          text="Back to all messages"
          onClick={() => navigate(`/dashboard/messages`)}
        ></Button>
      </div>
      <div className="chat-box">
        {messages?.length > 0 ? (
          messages.map((message) => (
            <ChatBar message={message} patientDetails={patientDetails} />
          ))
        ) : (
          <div className="start-conversation">
            <div className="dark-grey start-conversation-box">
              Start a conversation
            </div>
          </div>
        )}
      </div>
      <ChatEdit handleNewMessage={handleNewMessage} />
    </div>
  );
};

export default MessageSection;
